import React from 'react';
import * as UI from '@expert360/ui';
import { BREAKPOINTS } from 'utils/constants';

const styles = require('../../NotificationBanner.module.css');

const bainMessage = `Welcome ! You will soon be able to access Contracts in 'Browse
Projects'. For now, ensure your Profile looks exactly how you’d like
to be seen by us and Bain.`;

const NotificationBanner = () => {
  return (
    <UI.Container>
      <UI.Row className={styles.notificationRow}>
        <UI.Col>
          <UI.Text
            size={
              BREAKPOINTS.isSmallDown() ? UI.ESizes.Small : UI.ESizes.Medium
            }
          >
            {bainMessage}
          </UI.Text>{' '}
        </UI.Col>
      </UI.Row>
    </UI.Container>
  );
};

export default NotificationBanner;
